<template>
    <c-dialog ref="dialog" title="加班申请详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.document_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.document_number}}</label>
                <c-state dict="overtimeTypeDic" tag :value="detailData.overtime_type"></c-state>
                <c-state dict="applyStatusDic" tag :value="detailData.status"></c-state>
            </div>
        </template>

        <doc-base>
            <template #title>{{detailData.applicant_name}}_加班申请</template>
            <template #info>
                <c-field label="单据编号">{{detailData.document_number}}</c-field>
                <c-field label="关联售后工单" v-if="detailData.overtime_type == 1">
                    <c-link v-if="detailData.order_id && detailData.order_number" @click="globalDialog('afterSaleOrderDetail', {props: {id: detailData.order_id}})">{{detailData.order_number}}</c-link>
                    <span v-else>--</span>
                </c-field>
            </template>
        </doc-base>

        <doc-content>
            <c-field label="加班时长"><b>{{detailData.overtime_duration}}小时</b></c-field>
            <c-field label="加班事由">{{detailData.reason}}</c-field>
            <c-field label="加班凭证">
                <c-file-list :value="detailData.voucher_images" size="mini"></c-file-list>
            </c-field>
            <c-field label="加班明细" vertical>
                <c-table :data="detailData.detail_list" border :paging="false">
                    <c-table-column
                            label="加班申请人"
                            width="100"
                    >
                        <template #default="{data}">
                            <span>{{data.user_name}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="加班开始时间"
                            width="150"
                    >
                        <template #default="{data}">
                            <span>{{data.start_date}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="加班结束时间"
                            width="150"
                    >
                        <template #default="{data}">
                            <span>{{data.end_date}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="加班类型"
                            width="80"
                    >
                        <template #default="{data}">
                            <div v-for="(item, index) in data.holiday_types" :key="index">
                                 <c-state dict="overtimeDayTypeDic" :value="item"></c-state>
                            </div>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="加班时长"
                            width="80"
                    >
                        <template #default="{data}">
                            <span>{{data.overtime_duration}}（小时）</span>
                        </template>
                    </c-table-column>
                </c-table>
            </c-field>
            <c-field label="工单打卡记录" v-if="detailData.overtime_type==1 && detailData.order_id" vertical>
                <c-table :data="detailData.sign_list" border :paging="false">
                    <c-table-column label="售后工程师" width="100">
                        <template #default="{data}">
                            <span>{{data.user_realname}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="打卡类型" width="80">
                        <template #default="{data}">
                            <c-state dict="signTypeOptions" :value="data.sign_type"></c-state>
                        </template>
                    </c-table-column>

                    <c-table-column label="打卡时间" width="150">
                        <template #default="{data}">
                            <span>{{data.create_date}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="打卡地址" width="180">
                        <template #default="{data}">
                            <span>{{data.address_detail}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="备注" width="180">
                        <template #default="{data}">
                            <span>{{data.remark}}</span>
                        </template>
                    </c-table-column>
                </c-table>
            </c-field>
        </doc-content>

        <doc-log ref="docLog"></doc-log>

        <doc-handle
                ref="docHandle"
                :status="detailData.status"
                :applicant="detailData.is_founder == 1"
                :approver="detailData.is_approval == 1"
                @update="onHandleUpdate"
        ></doc-handle>
    </c-dialog>
</template>

<script>
export default {
    name: 'overtimeApplicationDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.update();
            this.$refs.dialog.open();
        },

        onHandleUpdate() {
            this.update();
            this.$bus.$emit('overtime_application_list.update');
        },

        update() {
            this.request({
                url: '/overtime/application/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.$refs.docLog.init(data.detailInfo.form_id);
                    this.$refs.docHandle.init(data.transaction);
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
